import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";
import { LayoutGrid, Camera, ShoppingCart, User } from "lucide-react";

/** Thumb-zone navigation for phones. Everything used to live in a small
 *  top-right hamburger — the hardest spot to reach one-handed.
 *  Hidden on /design/* where the sticky buy bar owns the bottom edge. */
export default function MobileTabBar() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const { items } = useCart();
  const count = items?.length || 0;

  if (pathname.startsWith("/design/")) return null;

  const tabs = [
    { to: "/marketplace", label: "Browse", icon: LayoutGrid, match: (p) => p === "/marketplace" || p === "/" },
    { to: "/visual-search", label: "Photo search", icon: Camera, match: (p) => p.startsWith("/visual-search") },
    { to: "/cart", label: "Cart", icon: ShoppingCart, match: (p) => p.startsWith("/cart"), badge: count },
    user
      ? { to: user.role === "seller" || user.role === "both" ? "/seller" : "/buyer", label: "Account", icon: User, match: (p) => p.startsWith("/seller") || p.startsWith("/buyer") }
      : { to: "/login", label: "Log in", icon: User, match: (p) => p.startsWith("/login") },
  ];

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-border bg-background/95 backdrop-blur-md pb-[env(safe-area-inset-bottom)]"
      data-testid="mobile-tab-bar"
    >
      <div className="grid grid-cols-4">
        {tabs.map((t) => {
          const on = t.match(pathname);
          return (
            <Link
              key={t.label}
              to={t.to}
              data-testid={`tab-${t.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`relative flex flex-col items-center justify-center gap-0.5 min-h-[56px] text-[10px] font-medium transition-colors ${on ? "text-primary" : "text-muted-foreground"}`}
            >
              <t.icon className="h-5 w-5" strokeWidth={on ? 2.4 : 1.8} />
              {t.label}
              {t.badge > 0 && (
                <span className="absolute top-1.5 right-[22%] bg-primary text-primary-foreground text-[9px] font-bold rounded-full min-w-[16px] h-4 px-1 flex items-center justify-center" data-testid="tab-cart-badge">
                  {t.badge}
                </span>
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
